export const profile = {
  name: 'David Lukcic, P.E., MBA',
  title: 'Chief Information & Technology Officer',
  location: 'Tampa, Florida, United States',
  phone: '+1 (813) 753-3277',
  phoneHref: 'tel:+18137533277',
  linkedIn: 'https://www.linkedin.com/in/davidlukcic/',
  emails: [
    { label: 'Personal', address: 'davidlukcic@gmail.com' },
    { label: 'Corporate', address: 'dmlukcic@tecoenergy.com' },
    { label: 'Alternate', address: 'dlukcic@gmail.com' },
  ],
  companies: [
    { label: 'Tampa Electric', href: 'https://www.tampaelectric.com' },
    { label: 'TECO Energy', href: 'https://www.tecoenergy.com' },
  ],
  headshot: 'https://cdn.magicpatterns.com/uploads/wbVb5eiYmuNTRxdfnn8iws/1784130393518.jpg',
  banner: 'https://cdn.magicpatterns.com/uploads/uKUPCZuwCpiKKdkRbGqeuK/1785842600952.jpg',
}

export const navigation = [
  { to: '/', label: 'Boardroom Summary', index: '01' },
  { to: '/governance', label: 'Governance & Capital', index: '02' },
  { to: '/stride', label: 'STRIDE Value', index: '03' },
  { to: '/infrastructure', label: 'Mega-Project Delivery', index: '04' },
  { to: '/technology', label: 'AI, OT & Cyber', index: '05' },
  { to: '/leadership', label: 'Culture & Credentials', index: '06' },
  { to: '/contact', label: 'Board Engagement', index: '07' },
]
